import { FunctionComponent, h } from 'preact'

export const Svg: FunctionComponent<{ className?: string; src: string }> = (
	props
) => {
	const { src: __html, ...rest } = props
	return <i dangerouslySetInnerHTML={{ __html }} {...rest} />
}
